// Number.isFinite(count) returns false if count is anything but a finite number, such as undefined or NaN.
// However, TypeScript doesn't know that, so we need to create a type guard to get the types to work out.
export const numberIsFinite = (number: unknown): number is number => Number.isFinite(number);
